import {lazyWithRetry} from '../../../../libs/ui/src';

export const LazyAccountsSettings = lazyWithRetry(() => import('./AccountSettings'));
